import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Div from '../Page/Div';
import { WPImage } from './WPImage';
import { Link } from 'react-router-dom';
/**
 * The investor cards carry no `name` -- the logo is the whole card -- so
 * `aria-label={name}` rendered as an empty string and left the link with no
 * discernible text at all. Falling back to the domain gives the link a name
 * an agent or screen reader can announce.
 */
const linkLabel = (url) => {
    try {
        return new URL(url).hostname.replace(/^www\./, '');
    }
    catch {
        return url;
    }
};
const TeamCard = ({ name, title, image, index, link, isHidden, externalHover, setExternalHover, }) => {
    const [hover, setHover] = useState(false);
    const isHover = externalHover ?? hover;
    const card = (_jsxs("div", { className: `team-card-wrapper${isHover ? ' hover' : ''}`, children: [_jsx("div", { className: "team-card-image", children: !!image && _jsx(WPImage, { id: image }) }), _jsxs("div", { className: "team-card-text", children: [_jsx("div", { className: "team-card-name", children: name }), _jsx("div", { className: "team-card-title", children: title })] })] }));
    return (_jsx(Div, { className: "product-card card team-card", onHover: (hover) => setExternalHover ? setExternalHover(hover) : setHover(hover), noScale: true, delay: 2 + index, hidden: isHidden, children: link ? (_jsx(Link, { to: link, target: "_blank", "aria-label": name || `Visit ${linkLabel(link)}`, children: card })) : (card) }, name));
};
export default TeamCard;
